import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { rContextAddon3rgt985u8pvgw as rContextAddon } from '../ViewContextExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_overlayFrame(_this__u8e3s4, _set____db54di) {
  _init_properties_AppNavV2_kt__p581vi();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_overlayFrame_$ref_166kt9_0();
  return overlayFrame$delegate.qam(_this__u8e3s4, getPropertyCallableRef('overlayFrame', 1, tmp, tmp_0, _set_overlayFrame_$ref_rwxo9j_0()), _set____db54di);
}
function get_overlayFrame(_this__u8e3s4) {
  _init_properties_AppNavV2_kt__p581vi();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_overlayFrame_$ref_166kt9();
  return overlayFrame$delegate.oam(_this__u8e3s4, getPropertyCallableRef('overlayFrame', 1, tmp, tmp_0, _set_overlayFrame_$ref_rwxo9j()));
}
var overlayFrame$delegate;
var coordinatorFrame$delegate;
function _get_overlayFrame_$ref_166kt9() {
  return (p0) => get_overlayFrame(p0);
}
function _set_overlayFrame_$ref_rwxo9j() {
  return (p0, p1) => {
    set_overlayFrame(p0, p1);
    return Unit_instance;
  };
}
function _get_overlayFrame_$ref_166kt9_0() {
  return (p0) => get_overlayFrame(p0);
}
function _set_overlayFrame_$ref_rwxo9j_0() {
  return (p0, p1) => {
    set_overlayFrame(p0, p1);
    return Unit_instance;
  };
}
var properties_initialized_AppNavV2_kt_ijh9wg;
function _init_properties_AppNavV2_kt__p581vi() {
  if (!properties_initialized_AppNavV2_kt_ijh9wg) {
    properties_initialized_AppNavV2_kt_ijh9wg = true;
    overlayFrame$delegate = rContextAddon(null);
    coordinatorFrame$delegate = rContextAddon(null);
  }
}
//region block: exports
export {
  get_overlayFrame as get_overlayFrameoxw7w6vy469q,
  set_overlayFrame as set_overlayFrame2h1srqihqvjg5,
};
//endregion

//# sourceMappingURL=AppNavV2.mjs.map
